"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSearchWidgetMachine = exports.machineJSON = void 0;
const xstate_1 = require("xstate");
const types_1 = require("../../types");
const states_1 = require("./states");
const events_1 = require("./events");
const services_1 = require("./services");
const actions_1 = require("./actions");
const guards_1 = require("./guards");
const constants_1 = require("../constants");
const fillInConfigDefaults_1 = require("../utils/fillInConfigDefaults");
const utils_1 = require("../utils");
const machineJSON = (initialState) => ({
    id: 'search_widget_machine',
    initial: initialState,
    states: {
        [states_1.States.INITIALIZING]: {
            initial: states_1.States.FETCHING_CONFIG,
            onDone: states_1.States.TYPEAHEAD_CLOSED,
            on: {
                [events_1.Events.INITIALIZE_STATE]: {
                    actions: actions_1.Actions.SET_STATE
                }
            },
            states: {
                [states_1.States.FETCHING_CONFIG]: {
                    invoke: {
                        id: services_1.Services.FETCH_CONFIG,
                        src: services_1.Services.FETCH_CONFIG,
                        onDone: {
                            actions: actions_1.Actions.SET_INCOMING_CONFIG,
                            target: states_1.States.FILLING_IN_CONFIG_DEFAUTLS
                        },
                        onError: { target: states_1.States.ERROR }
                    }
                },
                [states_1.States.FILLING_IN_CONFIG_DEFAUTLS]: {
                    invoke: {
                        id: services_1.Services.FILL_IN_CONFIG_DEFAULTS,
                        src: services_1.Services.FILL_IN_CONFIG_DEFAULTS,
                        onDone: [
                            {
                                cond: guards_1.Guards.RECEIVED_VALID_CONFIG,
                                actions: actions_1.Actions.SET_CONFIG,
                                target: states_1.States.CHECKING_LOGGER
                            },
                            { target: states_1.States.ERROR }
                        ],
                        onError: {
                            target: states_1.States.ERROR
                        }
                    }
                },
                [states_1.States.CHECKING_LOGGER]: {
                    always: [
                        {
                            cond: guards_1.Guards.HAS_VALID_LOGGER_IN_CONTEXT,
                            target: states_1.States.DONE
                        },
                        {
                            target: states_1.States.INITIALIZING_LOGGING
                        }
                    ]
                },
                [states_1.States.INITIALIZING_LOGGING]: {
                    invoke: {
                        id: services_1.Services.INITIALIZE_LOGGING,
                        src: services_1.Services.INITIALIZE_LOGGING,
                        onDone: {
                            actions: actions_1.Actions.SET_LOGGER,
                            target: states_1.States.DONE
                        },
                        onError: {
                            // TODO if we fail to initialize logging, should it be fatal?
                            target: states_1.States.ERROR
                        }
                    }
                },
                [states_1.States.ERROR]: {
                // fatal, could not load the config
                },
                [states_1.States.DONE]: { type: 'final' }
            }
        },
        [states_1.States.ACCEPTING_USER_INPUT]: {
            on: {
                [events_1.Events.SEND_LOCATION]: {
                    actions: actions_1.Actions.SET_LOCATION
                },
                [events_1.Events.SEND_TYPEAHEAD_TERMS]: {
                    // keep re-entering this state as the user types
                    actions: actions_1.Actions.SET_TYPEAHEAD_TERMS,
                    target: states_1.States.ACCEPTING_USER_INPUT
                },
                [events_1.Events.SUBMIT_FORM]: [
                    {
                        cond: guards_1.Guards.MISSING_TERMS_EMPTY_SEARCH_NOT_ALLOWED,
                        target: states_1.States.EMPTY_SEARCH_ERROR
                    },
                    { target: states_1.States.TYPEAHEAD_CLOSED }
                ]
            },
            after: {
                [constants_1.TYPEAHEAD_DEBOUNCE_DELAY]: [
                    {
                        cond: guards_1.Guards.TERMS_HAVE_SUFFICIENT_CHARACTER_COUNT,
                        target: states_1.States.FETCHING_TYPEAHEAD_SUGGESTIONS
                    },
                    { target: states_1.States.TYPEAHEAD_CLOSED }
                ]
            }
        },
        [states_1.States.TYPEAHEAD_CLOSED]: {
            on: {
                [events_1.Events.SEND_LOCATION]: {
                    // user types something into the input
                    actions: actions_1.Actions.SET_LOCATION
                },
                [events_1.Events.SEND_TYPEAHEAD_TERMS]: {
                    // user types something into the input
                    actions: actions_1.Actions.SET_TYPEAHEAD_TERMS,
                    target: states_1.States.ACCEPTING_USER_INPUT
                },
                [events_1.Events.OPEN_TYPEAHEAD]: {
                    cond: guards_1.Guards.HAS_VALID_SUGGESTIONS_IN_CONTEXT,
                    target: states_1.States.TYPEAHEAD_OPEN
                },
                [events_1.Events.INITIALIZE_STATE]: {
                    actions: actions_1.Actions.SET_STATE
                },
                [events_1.Events.SUBMIT_FORM]: [
                    {
                        cond: guards_1.Guards.MISSING_TERMS_EMPTY_SEARCH_NOT_ALLOWED,
                        target: states_1.States.EMPTY_SEARCH_ERROR
                    },
                    { target: states_1.States.TYPEAHEAD_CLOSED }
                ]
            }
        },
        [states_1.States.EMPTY_SEARCH_ERROR]: {
            on: {
                [events_1.Events.SEND_LOCATION]: {
                    // user types something into the input
                    actions: actions_1.Actions.SET_LOCATION
                },
                [events_1.Events.SEND_TYPEAHEAD_TERMS]: {
                    // user types something into the input
                    actions: actions_1.Actions.SET_TYPEAHEAD_TERMS,
                    target: states_1.States.ACCEPTING_USER_INPUT
                }
            }
        },
        [states_1.States.FETCHING_TYPEAHEAD_SUGGESTIONS]: {
            entry: actions_1.Actions.SET_API_START_TIME,
            invoke: {
                id: services_1.Services.FETCH_TYPEAHEAD_SUGGESTIONS,
                src: services_1.Services.FETCH_TYPEAHEAD_SUGGESTIONS,
                onDone: [
                    {
                        cond: guards_1.Guards.RECEIVED_VALID_TYPEAHEAD_SUGGESTIONS,
                        actions: actions_1.Actions.SET_TYPEAHEAD_SUGGESTIONS,
                        target: states_1.States.TYPEAHEAD_OPEN
                    },
                    {
                        actions: actions_1.Actions.SET_TYPEAHEAD_SUGGESTIONS,
                        target: states_1.States.NO_RESULTS
                    }
                ],
                onError: { target: states_1.States.ERROR }
            },
            on: {
                [events_1.Events.SEND_LOCATION]: {
                    // user types something into the input
                    actions: actions_1.Actions.SET_LOCATION
                },
                [events_1.Events.SEND_TYPEAHEAD_TERMS]: {
                    // user types something into the input,
                    actions: actions_1.Actions.SET_TYPEAHEAD_TERMS,
                    target: states_1.States.ACCEPTING_USER_INPUT
                }
            }
        },
        [states_1.States.TYPEAHEAD_OPEN]: {
            on: {
                [events_1.Events.SEND_LOCATION]: {
                    // user types something into the input
                    actions: actions_1.Actions.SET_LOCATION
                },
                [events_1.Events.SEND_TYPEAHEAD_TERMS]: {
                    // user types something into the input,
                    actions: actions_1.Actions.SET_TYPEAHEAD_TERMS,
                    target: states_1.States.ACCEPTING_USER_INPUT
                },
                [events_1.Events.CLOSE_TYPEAHEAD]: {
                    target: states_1.States.TYPEAHEAD_CLOSED
                },
                [events_1.Events.SUBMIT_FORM]: {
                    target: states_1.States.TYPEAHEAD_CLOSED
                }
            }
        },
        [states_1.States.NO_RESULTS]: {
            on: {
                [events_1.Events.SEND_LOCATION]: {
                    actions: actions_1.Actions.SET_LOCATION
                },
                [events_1.Events.SEND_TYPEAHEAD_TERMS]: {
                    actions: actions_1.Actions.SET_TYPEAHEAD_TERMS,
                    target: states_1.States.ACCEPTING_USER_INPUT
                },
                [events_1.Events.CLOSE_TYPEAHEAD]: {
                    target: states_1.States.TYPEAHEAD_CLOSED
                },
                [events_1.Events.SUBMIT_FORM]: {
                    target: states_1.States.TYPEAHEAD_CLOSED
                }
            }
        },
        [states_1.States.ERROR]: {
            // need a mock for this
            on: {
                [events_1.Events.SEND_LOCATION]: {
                    actions: actions_1.Actions.SET_LOCATION
                },
                [events_1.Events.SEND_TYPEAHEAD_TERMS]: {
                    actions: actions_1.Actions.SET_TYPEAHEAD_TERMS,
                    target: states_1.States.ACCEPTING_USER_INPUT
                },
                [events_1.Events.CLOSE_TYPEAHEAD]: {
                    target: states_1.States.TYPEAHEAD_CLOSED
                },
                [events_1.Events.SUBMIT_FORM]: {
                    target: states_1.States.TYPEAHEAD_CLOSED
                }
            }
        },
        [states_1.States.PREVIEW]: {
            entry: actions_1.Actions.SET_PREVIEW_TYPEAHEAD_SUGGESTIONS,
            on: {
                [events_1.Events.SEND_LOCATION]: {
                    actions: actions_1.Actions.SET_LOCATION
                }
            },
            // in preview mode, parallel states to independently force typeahead and error previews
            type: 'parallel',
            states: {
                typeahead: {
                    initial: states_1.States.TYPEAHEAD_CLOSED,
                    states: {
                        [states_1.States.TYPEAHEAD_OPEN]: {
                            on: {
                                [events_1.Events.CLOSE_TYPEAHEAD]: {
                                    target: states_1.States.TYPEAHEAD_CLOSED
                                }
                            }
                        },
                        [states_1.States.TYPEAHEAD_CLOSED]: {
                            on: {
                                [events_1.Events.OPEN_TYPEAHEAD]: {
                                    target: states_1.States.TYPEAHEAD_OPEN
                                }
                            }
                        }
                    }
                },
                error: {
                    initial: states_1.States.IDLE,
                    states: {
                        [states_1.States.IDLE]: {
                            on: {
                                [events_1.Events.PREVIEW_SHOW_ERROR]: {
                                    target: states_1.States.EMPTY_SEARCH_ERROR
                                }
                            }
                        },
                        [states_1.States.EMPTY_SEARCH_ERROR]: {
                            on: {
                                [events_1.Events.PREVIEW_HIDE_ERROR]: {
                                    target: states_1.States.IDLE
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
exports.machineJSON = machineJSON;
function createInitializedMachine(initialContext) {
    var _a, _b;
    const { log } = initialContext;
    const machine = (0, exports.machineJSON)(states_1.States.TYPEAHEAD_CLOSED);
    // can't get this far without a config, OK to non-null assert here
    const config = (0, fillInConfigDefaults_1.fillInConfigDefaults)({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        serverConfig: initialContext.serverConfig,
        useV8: (_a = initialContext.useV8) !== null && _a !== void 0 ? _a : false,
        useLegacyConfig: (_b = initialContext.useLegacyConfig) !== null && _b !== void 0 ? _b : false
    });
    // log function should always come from Search for initialized machines, but just in case...
    const logFunction = log && (0, types_1.isLogFunction)(log) ? log : (0, utils_1.initializeLogging)(config);
    const context = Object.assign(Object.assign({}, initialContext), { config, log: logFunction });
    return (0, xstate_1.createMachine)(machine)
        .withConfig({ actions: actions_1.actions, guards: guards_1.guards, services: services_1.services })
        .withContext(context);
}
function createNonInitialzedMachine(initialContext) {
    const machine = (0, exports.machineJSON)(states_1.States.INITIALIZING);
    return (0, xstate_1.createMachine)(machine)
        .withConfig({ actions: actions_1.actions, guards: guards_1.guards, services: services_1.services })
        .withContext(initialContext);
}
function createInitializedPreviewMachine(initialContext) {
    var _a, _b;
    const machine = (0, exports.machineJSON)(states_1.States.PREVIEW);
    // can't get this far without a config, OK to non-null assert here
    const config = (0, fillInConfigDefaults_1.fillInConfigDefaults)({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        serverConfig: initialContext.serverConfig,
        useV8: (_a = initialContext.useV8) !== null && _a !== void 0 ? _a : false,
        useLegacyConfig: (_b = initialContext.useLegacyConfig) !== null && _b !== void 0 ? _b : false
    });
    const context = Object.assign(Object.assign({}, initialContext), { config, log: () => {
            /** */
        } });
    return (0, xstate_1.createMachine)(machine)
        .withConfig({ actions: actions_1.actions, guards: guards_1.guards, services: services_1.services })
        .withContext(context);
}
// There are three use cases for the SearchWidget
//
// - Using the react component `<SearchWidget ... />` :
//   - In this case, we pass all configuration required to render the component
//   - There is not a loading state
//   - The machine starts from `TYPEAHEAD_CLOSED` state
//
// - Embedded on a customer's site:
//    - In this case, the component loads and then `fetches` the configuration
//    - We show a `loading` state while `fetching` the config
//    - The machine starts from `INITIALIZING` state
//
// - Preview mode:
//    - only happens in the search widget admin tool
//    - typeahead being open is controlled by the tool and we render dummy data
const createSearchWidgetMachine = (initialContext, options) => {
    if (options === null || options === void 0 ? void 0 : options.previewMode) {
        return createInitializedPreviewMachine(initialContext);
    }
    else if (initialContext.serverConfig) {
        return createInitializedMachine(initialContext);
    }
    else {
        return createNonInitialzedMachine(initialContext);
    }
};
exports.createSearchWidgetMachine = createSearchWidgetMachine;
//# sourceMappingURL=machine.js.map